module.exports = __webpack_public_path__ + "static/media/DFPHannotateW5-B5-TW.0365bc84.svg";